export const GTM_ID_TEST = 'GTM-5HVNBW5';
export const GTM_ID = 'GTM-NHHV9N7';

export default {
  GTM_ID_TEST,
  GTM_ID,
};
